/**
 * Orca Dashboard route — eagerly registers the route + `beforeLoad` SSR loader
 * but defers component + atom imports via `.lazy.tsx`. This keeps the orca
 * admin chunk out of the bundle for non-admin users on every other route.
 *
 * The eager file may import NO atoms/components/design modules (bundle budgets):
 * the v5 frame's stylesheet is linked from {@link boardHead} via the pure
 * `~/lib/orcaloops-head.ts` (web CLAUDE.md rule 6).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";
import { orcaTasksBeforeLoad } from "~/lib/orca-ssr.ts";
import { orcaloopsStylesheetLinks } from "~/lib/orcaloops-head.ts";

/**
 * The page's head: the orcaloops frame stylesheet, render-blocking, so the SSR
 * markup paints styled.
 *
 * @since 1.0.0
 */
export const boardHead = () => ({ links: orcaloopsStylesheetLinks });

export const Route = createFileRoute("/orca/")({
  beforeLoad: orcaTasksBeforeLoad,
  head: boardHead,
});
